<ng-container *ngFor="let e of viewModel">
    <bs-alert [message]="getMessage(e)" [title]="getTitle(e)" [type]="getType(e)" (click)="redirectFromErrorMessage($event)"></bs-alert>
</ng-container>
